export enum ReviewDaoRequestKey {
	BYPRODUCTID = 'Reviews DAO By Product ID',
	LIST = 'Reviews DAO List',
	MULTIMEDIA = 'Reviews DAO Multimedia',
	STATISTICS = 'Reviews Statistics DAO',
	SUBMITFEEDBACK = 'Reviews DAO Submit Feedback'
}

export enum ReviewRequestKey {
	AISUMMARY = 'Reviews AI Summary',
	LIST = 'Reviews List',
	MULTIMEDIA = 'Reviews Multimedia',
	PROSCONS = 'Reviews Pros Cons',
	REVIEWS = 'Reviews',
	STATISTICS = 'Reviews Statistics',
	SUBMITFEEDBACK = 'Reviews Submit Feedback'
}